import { useMutation, useQueryClient } from 'react-query';
import {
  createSchoolShiftAsync,
  updateSchoolShiftAsync,
  deleteSchoolShiftAsync,
} from '../../index';
import { SCHOOL_SHIFT_KEYS } from '../useQuery';
import { ISchoolShiftUpdateParams } from 'services/SchoolShift/types';

export const useCreateSchoolShiftAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(createSchoolShiftAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([SCHOOL_SHIFT_KEYS.ALL, SCHOOL_SHIFT_KEYS.LIST]);
      queryClient.invalidateQueries([SCHOOL_SHIFT_KEYS.ALL, SCHOOL_SHIFT_KEYS.COUNT]);
    },
  });
};

export const useUpdateSchoolShiftAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(updateSchoolShiftAsync, {
    onSuccess: (_, variables: ISchoolShiftUpdateParams) => { 
      queryClient.invalidateQueries([SCHOOL_SHIFT_KEYS.ALL, SCHOOL_SHIFT_KEYS.LIST]);
      queryClient.invalidateQueries([SCHOOL_SHIFT_KEYS.ALL, SCHOOL_SHIFT_KEYS.DETAIL, variables.id]); 
    },
  });
};

export const useDeleteSchoolShiftAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteSchoolShiftAsync, {
    onSuccess: (_, deletedId) => {
      queryClient.removeQueries([SCHOOL_SHIFT_KEYS.ALL, SCHOOL_SHIFT_KEYS.DETAIL, deletedId]);
      queryClient.invalidateQueries([SCHOOL_SHIFT_KEYS.ALL, SCHOOL_SHIFT_KEYS.LIST]);
      queryClient.invalidateQueries([SCHOOL_SHIFT_KEYS.ALL, SCHOOL_SHIFT_KEYS.COUNT]);
    },
  });
};